<main class="dashboard" *ngIf="user">
  <section class="dashboard-layout-card">
    <div class="dashboard-content">
  <section class="welcome-panel">
    <div>
      <h1 class="sam-page-heading">Hej {{firstName}}, vad vill du göra idag?</h1>
    </div>
  </section>

  <div *ngIf="user.suspended" class="dashboard-warning" role="alert">
    <mat-icon>warning</mat-icon>
    <span>Ditt konto är spärrat på grund av misstänkt missbruk eller brott mot våra villkor. Kontakta supporten.</span>
  </div>

  <section class="quick-actions" aria-label="Snabbval">
    <a class="quick-action" [routerLink]="createInvoiceLink">
      <span class="quick-icon pink"><mat-icon>playlist_add</mat-icon></span>
      <span><strong>{{createInvoiceLabel}}</strong><small>Skapa ett nytt underlag</small></span>
      <mat-icon class="arrow">chevron_right</mat-icon>
    </a>
    <a class="quick-action" [routerLink]="invoiceListLink">
      <span class="quick-icon blue"><mat-icon>find_in_page</mat-icon></span>
      <span><strong>Se fakturor</strong><small>Följ status och historik</small></span>
      <mat-icon class="arrow">chevron_right</mat-icon>
    </a>
    <a class="quick-action" routerLink="/mypages/customers">
      <span class="quick-icon green"><mat-icon>person_add_alt</mat-icon></span>
      <span><strong>Hantera kunder</strong><small>Visa och uppdatera kunder</small></span>
      <mat-icon class="arrow">chevron_right</mat-icon>
    </a>
  </section>

  <section class="dashboard-grid functional-dashboard-grid">
    <div class="dashboard-column main-column">
      <article class="dashboard-card payments-card" *ngIf="appId === 1">
        <div class="card-heading">
          <div><h2>Kommande löner</h2></div>
          <a mat-button routerLink="/transactions">Visa alla</a>
        </div>

        <div class="modern-skeleton" *ngIf="isInvoiceLoading" aria-hidden="true">
          <div class="modern-skeleton-row" *ngFor="let row of invoiceSkeletonRows">
            <span class="modern-skeleton-icon"></span>
            <span class="modern-skeleton-copy"></span>
            <span class="modern-skeleton-value"></span>
          </div>
        </div>

        <div class="payment-list" *ngIf="!isInvoiceLoading && invoiceData.length > 0; else noUpcomingPayouts">
          <a class="payment-row" *ngFor="let invoiceItem of invoiceData" routerLink="/transactions">
            <span class="payment-icon"><mat-icon>description</mat-icon></span>
            <span class="payment-copy">
              <strong>{{invoiceItem.Customer?.Name || invoiceItem.RecieverCompanyName}}</strong>
              <small>{{getUpcomingPayoutLog(invoiceItem)?.IsPreliminary ? 'Preliminär utbetalning' : 'Kommande utbetalning'}}</small>
            </span>
            <span class="payment-value">
              <small>
                {{invoiceItem.PaymentDue | swedishDate:'yyyy-MM-dd'}}
                <mat-icon *ngIf="getUpcomingPayoutLog(invoiceItem)?.IsPreliminary"
                          matTooltip="Detta är ett preliminärt datum">info</mat-icon>
              </small>
              <strong *ngIf="getUpcomingPayoutAmount(invoiceItem) as payoutAmount; else payoutPending">
                {{payoutAmount | number:'1.0-2'}} SEK
              </strong>
              <ng-template #payoutPending><strong>Beräknas</strong></ng-template>
            </span>
            <mat-icon>chevron_right</mat-icon>
          </a>
        </div>

        <ng-template #noUpcomingPayouts>
          <div class="card-empty-state" *ngIf="!isInvoiceLoading">
            <mat-icon>event_available</mat-icon>
            <strong>Inga kommande utbetalningar</strong>
            <span>Nya preliminära utbetalningar visas här.</span>
          </div>
        </ng-template>
      </article>

      <article class="dashboard-card payments-card" *ngIf="appId === 2">
        <div class="card-heading">
          <div><h2>Skickade fakturor</h2></div>
          <a mat-button routerLink="/organization/invoices">Visa alla</a>
        </div>

        <div class="modern-skeleton" *ngIf="isInvoiceLoading" aria-hidden="true">
          <div class="modern-skeleton-row" *ngFor="let row of invoiceSkeletonRows">
            <span class="modern-skeleton-icon"></span>
            <span class="modern-skeleton-copy"></span>
            <span class="modern-skeleton-value"></span>
          </div>
        </div>

        <div class="payment-list" *ngIf="!isInvoiceLoading && sentInvoiceData.length > 0; else noCompanyInvoices">
          <a class="payment-row" *ngFor="let invoiceItem of sentInvoiceData" routerLink="/organization/invoices">
            <span class="payment-icon blue"><mat-icon>receipt_long</mat-icon></span>
            <span class="payment-copy">
              <strong>Faktura {{invoiceItem.InvoiceNumber}}</strong>
              <small>{{invoiceItem.Status?.Name || 'Status saknas'}}</small>
            </span>
            <span class="payment-value">
              <small>Förfaller {{invoiceItem.PaymentDue | swedishDate:'yyyy-MM-dd'}}</small>
              <strong>{{invoiceItem.TotalInvoiceAmountIncVat | number:'1.2-2'}} SEK</strong>
            </span>
            <mat-icon>chevron_right</mat-icon>
          </a>
        </div>

        <ng-template #noCompanyInvoices>
          <div class="card-empty-state" *ngIf="!isInvoiceLoading">
            <mat-icon>receipt_long</mat-icon>
            <strong>Inga skickade fakturor</strong>
            <a mat-button color="accent" routerLink="/combined-invoice-tool">Skapa en faktura</a>
          </div>
        </ng-template>
      </article>

      <article class="dashboard-card calculator-card modern-calculator" *ngIf="appId === 1">
        <div class="card-heading calculator-heading">
          <div><h2>Kalkylator</h2></div>
        </div>

        <mat-tab-group color="accent" mat-stretch-tabs="false" dynamicHeight>
          <mat-tab>
            <ng-template mat-tab-label><mat-icon>attach_money</mat-icon>Din lön</ng-template>

            <div class="calculator-content">
              <mat-slide-toggle color="accent" [(ngModel)]="samFeeSlide">Express</mat-slide-toggle>

              <ng-container *ngIf="!samFeeSlide">
                <div class="calculator-fields">
                  <mat-form-field appearance="outline">
                    <mat-label>Belopp du ska fakturera</mat-label>
                    <input matInput type="text" inputmode="decimal" [disabled]="user?.Municipality?.Tax == 0"
                           [ngModel]="amountInputs.salary" (ngModelChange)="onSalaryAmountInput($event, false)"
                           (blur)="formatEditableAmount('salary', totalInvoiceAmount)" />
                    <mat-icon matSuffix>description</mat-icon>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Belopp efter skatt</mat-label>
                    <input matInput type="text" readonly [value]="formatAmount(netSalary)" />
                    <mat-icon matSuffix>payments</mat-icon>
                  </mat-form-field>
                </div>

                <mat-expansion-panel *ngIf="totalInvoiceAmount" class="calculation-details" hideToggle
                                     (opened)="panelOpenStateCalc = true" (closed)="panelOpenStateCalc = false">
                  <mat-expansion-panel-header>
                    <mat-panel-title>Se hur vi har räknat</mat-panel-title>
                    <mat-icon>{{panelOpenStateCalc ? 'remove' : 'add'}}</mat-icon>
                  </mat-expansion-panel-header>
                  <div class="calculation-row"><span>Fakturabelopp exkl. moms</span><strong>{{formatAmount(totalInvoiceAmount)}} SEK</strong></div>
                  <div class="calculation-row"><span>SAMpoolen-avgift</span><strong>{{formatAmount(samFeeNew)}} SEK</strong></div>
                  <div class="calculation-row"><span>Sociala avgifter</span><strong>{{formatAmount(arbetsgivarAvgift)}} SEK</strong></div>
                  <div class="calculation-row"><span>Bruttolön</span><strong>{{formatAmount(grossSalary)}} SEK</strong></div>
                  <div class="calculation-row"><span>Kommunalskatt ({{formatAmount(municipalitytax * 100)}} %)</span><strong>{{formatAmount(displayTax)}} SEK</strong></div>
                  <div class="calculation-row total"><span>Nettolön</span><strong>{{formatAmount(netSalary)}} SEK</strong></div>
                </mat-expansion-panel>
              </ng-container>

              <ng-container *ngIf="samFeeSlide">
                <div class="calculator-fields">
                  <mat-form-field appearance="outline">
                    <mat-label>Belopp du ska fakturera</mat-label>
                    <input matInput type="text" inputmode="decimal" [disabled]="user?.Municipality?.Tax == 0"
                           [ngModel]="amountInputs.salaryExpress" (ngModelChange)="onSalaryAmountInput($event, true)"
                           (blur)="formatEditableAmount('salaryExpress', totalInvoiceAmountExpress)" />
                    <mat-icon matSuffix>description</mat-icon>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Belopp efter skatt</mat-label>
                    <input matInput type="text" readonly [value]="formatAmount(netSalaryExpress)" />
                    <mat-icon matSuffix>payments</mat-icon>
                  </mat-form-field>
                </div>

                <mat-expansion-panel *ngIf="totalInvoiceAmountExpress" class="calculation-details" hideToggle
                                     (opened)="panelOpenStateCalc = true" (closed)="panelOpenStateCalc = false">
                  <mat-expansion-panel-header>
                    <mat-panel-title>Se hur vi har räknat</mat-panel-title>
                    <mat-icon>{{panelOpenStateCalc ? 'remove' : 'add'}}</mat-icon>
                  </mat-expansion-panel-header>
                  <div class="calculation-row"><span>Fakturabelopp exkl. moms</span><strong>{{formatAmount(totalInvoiceAmountExpress)}} SEK</strong></div>
                  <div class="calculation-row"><span>SAMpoolen-avgift ({{formatAmount(samFeeExpress * 100)}} %)</span><strong>{{formatAmount(samFeeNew)}} SEK</strong></div>
                  <div class="calculation-row"><span>Sociala avgifter</span><strong>{{formatAmount(arbetsgivarAvgift)}} SEK</strong></div>
                  <div class="calculation-row"><span>Bruttolön</span><strong>{{formatAmount(grossSalary)}} SEK</strong></div>
                  <div class="calculation-row"><span>Kommunalskatt ({{formatAmount(municipalitytax * 100)}} %)</span><strong>{{formatAmount(displayTax)}} SEK</strong></div>
                  <div class="calculation-row total"><span>Nettolön</span><strong>{{formatAmount(netSalaryExpress)}} SEK</strong></div>
                </mat-expansion-panel>
              </ng-container>

              <p class="calculator-tax-message" *ngIf="municipalityTaxMessage">{{municipalityTaxMessage}}</p>
            </div>
          </mat-tab>

          <mat-tab>
            <ng-template mat-tab-label><mat-icon>swap_horiz</mat-icon>Inkl./exkl. moms</ng-template>
            <div class="calculator-content vat-calculator">
              <p>Räkna ut ett belopp med eller utan moms.</p>
              <mat-button-toggle-group name="changeVat" [(ngModel)]="vatButton" aria-label="Momssats">
                <mat-button-toggle [value]="1">25 %</mat-button-toggle>
                <mat-button-toggle [value]="2">12 %</mat-button-toggle>
                <mat-button-toggle [value]="3">6 %</mat-button-toggle>
                <mat-button-toggle [value]="4">0 %</mat-button-toggle>
              </mat-button-toggle-group>

              <div class="calculator-fields" *ngIf="vatButton === 1">
                <mat-form-field appearance="outline"><mat-label>Belopp utan 25 % moms</mat-label><input matInput type="text" inputmode="decimal" [ngModel]="amountInputs.noVat" (ngModelChange)="onVatAmountInput('noVat', $event)" (blur)="formatEditableAmount('noVat', noVat)" /></mat-form-field>
                <mat-form-field appearance="outline"><mat-label>Belopp med 25 % moms</mat-label><input matInput type="text" inputmode="decimal" [ngModel]="amountInputs.withVat" (ngModelChange)="onVatAmountInput('withVat', $event)" (blur)="formatEditableAmount('withVat', withVat)" /></mat-form-field>
              </div>
              <div class="calculator-fields" *ngIf="vatButton === 2">
                <mat-form-field appearance="outline"><mat-label>Belopp utan 12 % moms</mat-label><input matInput type="text" inputmode="decimal" [ngModel]="amountInputs.noVatMedium" (ngModelChange)="onVatAmountInput('noVatMedium', $event)" (blur)="formatEditableAmount('noVatMedium', noVatMedium)" /></mat-form-field>
                <mat-form-field appearance="outline"><mat-label>Belopp med 12 % moms</mat-label><input matInput type="text" inputmode="decimal" [ngModel]="amountInputs.withVatMedium" (ngModelChange)="onVatAmountInput('withVatMedium', $event)" (blur)="formatEditableAmount('withVatMedium', withVatMedium)" /></mat-form-field>
              </div>
              <div class="calculator-fields" *ngIf="vatButton === 3">
                <mat-form-field appearance="outline"><mat-label>Belopp utan 6 % moms</mat-label><input matInput type="text" inputmode="decimal" [ngModel]="amountInputs.noVatLow" (ngModelChange)="onVatAmountInput('noVatLow', $event)" (blur)="formatEditableAmount('noVatLow', noVatLow)" /></mat-form-field>
                <mat-form-field appearance="outline"><mat-label>Belopp med 6 % moms</mat-label><input matInput type="text" inputmode="decimal" [ngModel]="amountInputs.withVatLow" (ngModelChange)="onVatAmountInput('withVatLow', $event)" (blur)="formatEditableAmount('withVatLow', withVatLow)" /></mat-form-field>
              </div>
              <div class="calculator-fields" *ngIf="vatButton === 4">
                <mat-form-field appearance="outline"><mat-label>Belopp utan moms</mat-label><input matInput type="text" inputmode="decimal" [ngModel]="amountInputs.zeroVatAmount" (ngModelChange)="onVatAmountInput('zeroVatAmount', $event)" (blur)="formatEditableAmount('zeroVatAmount', zeroVatAmount)" /></mat-form-field>
                <mat-form-field appearance="outline"><mat-label>Belopp med moms</mat-label><input matInput type="text" inputmode="decimal" [ngModel]="amountInputs.zeroVatAmount" (ngModelChange)="onVatAmountInput('zeroVatAmount', $event)" (blur)="formatEditableAmount('zeroVatAmount', zeroVatAmount)" /></mat-form-field>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </article>
    </div>

    <div class="dashboard-column side-column">
      <article class="dashboard-card message-card live-message-card">
        <div class="card-heading">
          <div><h2>Meddelanden</h2></div>
          <span class="message-count" *ngIf="unreadMessageCount > 0">{{unreadMessageCount}} nya</span>
        </div>

        <div class="live-message-list" *ngIf="globalmessages.length > 0; else noMessages">
          <button type="button" class="live-message-item" *ngFor="let message of globalmessages" (click)="openDialog(message)">
            <span class="message-status" [class.is-read]="message.IsRead"></span>
            <span class="live-message-copy"><strong>{{message.Headline}}</strong><small>{{message.DateStart | swedishDate:'yyyy-MM-dd'}}</small></span>
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>

        <ng-template #noMessages>
          <div class="message-preview compact-message-preview">
            <span class="message-art"><mat-icon>mark_email_read</mat-icon></span>
            <strong>Inga nya meddelanden</strong>
            <p>Meddelanden från {{productName}} visas här.</p>
          </div>
        </ng-template>
      </article>

      <article class="dashboard-card referral-card" *ngIf="appId === 1">
        <div class="card-heading">
          <div><h2>Värvningskod</h2></div>
          <span class="referral-icon"><mat-icon>group_add</mat-icon></span>
        </div>
        <p>Här är din personliga värvningskod:</p>
        <div class="referral-code-row">
          <strong class="referral-code">{{user?.ReferralCode}}</strong>
          <button type="button" class="copy-referral-code"
                  [disabled]="!user?.ReferralCode" (click)="copyReferralCode()"
                  matTooltip="Kopiera värvningskod" aria-label="Kopiera värvningskod">
            <mat-icon>content_copy</mat-icon>
          </button>
        </div>
      </article>
    </div>
  </section>

  <footer class="dashboard-footer"><span>© {{year}} – SAMgruppen AB</span><span>Alla belopp exkl. moms</span></footer>
    </div>
  </section>
</main>
